'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chart_utility = require('../../../../packages/common-utilities/src/chart_utility');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

var _number_utility = require('../../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _formatted_number = require('../global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _reactIntl = require('react-intl');

var _string_utility = require('../../../../packages/common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RollingReturnsChart = function (_React$Component) {
  _inherits(RollingReturnsChart, _React$Component);

  function RollingReturnsChart() {
    _classCallCheck(this, RollingReturnsChart);

    return _possibleConstructorReturn(this, (RollingReturnsChart.__proto__ || Object.getPrototypeOf(RollingReturnsChart)).apply(this, arguments));
  }

  _createClass(RollingReturnsChart, [{
    key: 'createRollingReturnsChart',

    /* eslint-disable*/
    value: function createRollingReturnsChart(printWidth) {
      var data = this.createRollingReturnsChartData(this.props.rollingReturnsData);
      var isDesktop = this.props.breakpoint > 3;
      var xAxisTicks = this.props.rollingReturnsData.headers;
      var marginRight = isDesktop ? 20 : 10;
      var yAxisTicks = this.getRollingReturnsTicks(data);
      var numberFormat = this.props.numberFormat;
      var intl = this.props.intl;
      var shareclassName = this.props.rollingReturnsData.rollingPerformanceData[0].performanceFactor;

      var spec = {
        "label": {
          "show": false
        },
        "selector": "#RollingReturnsChart",
        "keys": ["date", "type"],
        "values": ["return"],
        "type": "grouped",
        "container": {
          "marginBottom": 70,
          "marginLeft": 50,
          "scaled": true,
          "marginRight": marginRight,
          "height": 550
        },
        "style": {
          "fill": ["#B37E1B", "#70C4FF", "#00A16D"]
        },
        "axis": {
          "x": {
            "show": true,
            "domain": [xAxisTicks[0], xAxisTicks[xAxisTicks.length - 1]],
            "tick": {
              "values": xAxisTicks
            },
            "label": {
              "show": true,
              "style": {
                "font-family": "NBInternational",
                "font-size": "12px"
              }
            }
          },
          "y": {
            "domain": [yAxisTicks[0], yAxisTicks[yAxisTicks.length - 1]],
            "show": true,
            "ticks": yAxisTicks.length,
            "tick": {
              "padding": 10,
              "values": yAxisTicks,
              "grid": true,
              "style": {
                "stroke": "lightgrey"
              }
            },
            "label": {
              "style": {
                "font-family": "NBInternational",
                "font-size": "12px"
              },
              "text": function text(d) {
                return d * 100 + "%";
              }
            }
          }
        },
        "mouseoverHandler": function mouseoverHandler(d, node) {
          if (d3.select(node).select("#definition").empty()) {
            var def = d3.select(node).append("defs").attr("id", "definition");

            def.append("pattern").attr("id", "pattern0").attr("patternContentUnits", "objectBoundingBox").attr("width", 2.5).attr("height", "0.162602").append("use").attr("xlink:href", "#image0_859_24439").attr("transform", "scale(0.0625 0.00406504)");
            def.append("image").attr("id", "image0_859_24439").attr("width", 40).attr("height", 40).attr("xlink:href", imgUrl + "/images/overlay.png");
          }
          var width = d3.select(node).node().getBBox().width;
          var height = d3.select(node).node().getBBox().height;

          if (d3.select(node).select("#patternRect").empty()) {
            d3.select(node).append("rect").attr("height", height).attr("width", width).attr("id", "patternRect").style("fill", "url(#pattern0)");
          }
        },
        "mouseoutHandler": function mouseoutHandler(d, node) {
          if (d3.event.relatedTarget.id === "patternRect") {
            return;
          }

          if (!d3.select(node).select("#definition").empty()) {
            d3.select(node).select("#definition").remove();
          }

          if (!d3.select(node).select("#patternRect").empty()) {
            d3.select(node).select("#patternRect").remove();
          }
        },
        "tooltip": {
          "show": true,
          "type": "snap",
          "container": "body",
          "arrow": {
            "show": true,
            "height": 10,
            "width": 20
          },
          "style": {
            "color": "#2b2b2b",
            "font-family": "NBInternational",
            "font-size": "14px",
            "font-weight": "300",
            "padding-top": "14px",
            "padding-bottom": "14px",
            "padding-right": "14px",
            "padding-left": "14px",
            "opacity": 0.95,
            "offsetX": 15,
            "offsetY": 5,
            "fill": "black",
            "background-color": "white",
            "border-width": "1px",
            "border-style": "solid",
            "border-color": "#c9c9c9",
            "box-shadow": "0 4px 30px 0 rgba(0, 0, 0, 0.16)"
          },
          "text": function text(data) {
            var color = data.return > 0 ? '#00a22a' : '#e20000';
            var tooltipLabel = data.type === "Shareclass" ? shareclassName : _string_utility2.default.getLocalizedString(intl, data.type, data.type);
            var formattedValue = _formatted_number2.default.prototype.numberFormatter(_number_utility2.default.convertDecimalToPercentWith2FixedDecimals(data.return), numberFormat);

            var tooltiptext = "<div style ='padding:2px'>";
            tooltiptext += "<div style= 'text-align:left;  font-weight:100;' class='caption'> " + data.date + "</div>";
            tooltiptext += "<div style = 'text-align:left;'>" + tooltipLabel + ": " + "<span class='caption' style='font-weight: 400; color: " + color + "'>" + formattedValue + "</span> </div>";
            tooltiptext += "</div>";
            return tooltiptext;
          }
        },
        "postProcessing": function postProcessing(chart) {
          chart.getPlot().selectAll("line").style("stroke", "lightgrey");
          var xAxisLines = chart.getPlot().selectAll("line");
          var zeroIndex = chart.getYAxis().tick.values.indexOf(0);
          xAxisLines._groups[0][zeroIndex].style.stroke = "black";
        }

      };

      if (printWidth && typeof printWidth === "number") {
        spec.width = (0, _chart_utility.getChartPrintWidth)();
        spec.height = (0, _chart_utility.getChartPrintHeight)();
      }

      return _chart_utility2.default.generateChart((0, _chart_utility.generateChartId)("RollingReturnsChart", printWidth && typeof printWidth === "number"), "bar", data, spec);
    }
  }, {
    key: 'getRollingReturnsTicks',
    value: function getRollingReturnsTicks(data) {
      var maxPositiveValue = Math.max.apply(Math, data.map(function (o) {
        return o.return;
      }));
      var maxNegativeValue = Math.min.apply(Math, data.map(function (o) {
        return o.return;
      }));

      var largestValue = maxPositiveValue > Math.abs(maxNegativeValue) ? maxPositiveValue : Math.abs(maxNegativeValue);
      largestValue *= 100;

      var smallestPermittedMaxValue = 20;
      var tickIncrement = 10;

      if (largestValue > 10) {
        largestValue = Math.ceil(largestValue / 10) * 10;
      } else if (largestValue < 5) {
        smallestPermittedMaxValue = 5;
        tickIncrement = 1;
      } else {
        smallestPermittedMaxValue = 10;
        tickIncrement = 2;
      }

      if (largestValue < smallestPermittedMaxValue) {
        largestValue = smallestPermittedMaxValue;
      }

      var currentTick = largestValue * -1;
      var ticks = [];
      while (currentTick <= largestValue) {
        ticks.push(currentTick / 100);
        currentTick += tickIncrement;
      }
      return ticks;
    }
  }, {
    key: 'createRollingReturnsChartData',
    value: function createRollingReturnsChartData(data) {
      var shareclassData = data.headers.map(function (item, index) {
        return {
          date: item,
          type: 'Shareclass',
          return: data.rollingPerformanceData[0].values[index]
        };
      });

      var benchmarkData = data.headers.map(function (item, index) {
        return {
          date: item,
          type: 'Benchmark',
          return: data.rollingPerformanceData.length > 1 ? data.rollingPerformanceData[1].values[index] : null
        };
      });

      var salesChargeData = data.headers.map(function (item, index) {
        return {
          date: item,
          type: 'net-of-fees',
          return: data.rollingPerformanceData.length === 4 ? data.rollingPerformanceData[3].values[index] : null
        };
      });

      return salesChargeData.concat(shareclassData).concat(benchmarkData);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.rollingReturnsData.length === 0) {
        return null;
      }
      var chart = this.createRollingReturnsChart();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'print-hide' },
          _react2.default.createElement(chart)
        ),
        _react2.default.createElement(
          'div',
          { className: 'print-display', style: { display: "none" } },
          _react2.default.createElement(this.createRollingReturnsChart(800))
        )
      );
    }
  }]);

  return RollingReturnsChart;
}(_react2.default.Component);

/* eslint-enable*/


exports.default = (0, _reactIntl.injectIntl)(RollingReturnsChart);